import { NgClass } from '@angular/common';
import { NgModule } from '@angular/core';

import { BadgeComponent } from './badge.component';

/**
 * Angular module providing badge component functionality.
 *
 * @remarks
 * This module exports the {@link BadgeComponent} and handles its dependencies.
 * Import this module to use badge components in your application.
 *
 * @example
 *
 * ```typescript
 * import { BadgeModule } from '@backbase/ui-ang/badge';
 *
 * @NgModule({
 *   imports: [BadgeModule]
 * })
 * export class MyModule {}
 * ```
 */
@NgModule({
  imports: [NgClass],
  declarations: [BadgeComponent],
  exports: [BadgeComponent],
})
export class BadgeModule {}
